export default __webpack_public_path__ + "static/media/in3.eba0509c.jpg";